export const ASK_HELIX_ANSWER_VERDICT_STATUSES = Object.freeze([
  'decision_grade',
  'decision_grade_with_labels',
  'degraded',
  'blocked_named_gaps',
] as const);

export type AskHelixAnswerVerdictStatusDto =
  (typeof ASK_HELIX_ANSWER_VERDICT_STATUSES)[number];
